import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute from '../components/utils/private-route';
import { Screens } from '../screens';
import { Paths } from './paths';

export const Routes = (): JSX.Element => (
  <Switch>
    <Route exact={true} path={Paths.login} component={Screens.Login} />
    <PrivateRoute exact={false} path={Paths.dashboard} component={Screens.MainScreen} />
  </Switch>
);

export const InnerRoutes = (): JSX.Element => (
  <Switch>
    <Route exact={true} path={Paths.dashboard} component={Screens.Dashboard} />
    <Route exact={true} path={Paths.personal_data} component={Screens.PersonalData} />
    <Route exact={true} path={Paths.profile} component={Screens.Profile} />
    <Route exact={true} path={Paths.settings} component={Screens.Settings} />
    <Route exact={true} path={Paths.contact} component={Screens.Contact} />
    <Route exact={true} path={Paths.notifications} component={Screens.Notifications} />
    <Route exact={true} path={Paths.login_settings} component={Screens.LoginSettings} />
    <Route exact={true} path={Paths.logout_settings} component={Screens.LogoutSettings} />
    <Route exact={true} path={Paths.locale_settings} component={Screens.LocaleSettings} />
    <Route exact={true} path={Paths.password_change} component={Screens.PasswordChange} />
    <Route exact={true} path={Paths.messages} component={Screens.Messages} />
    <Route exact={true} path={Paths.exchange_orders} component={Screens.ExchangeOrders} />
    <Route exact={true} path={Paths.new_exchange_order} component={Screens.NewExchangeOrder} />
    <Route
      exact={true}
      path={Paths.exchange_order_details}
      component={Screens.ExchangeOrderDetails}
    />
    <Route exact={true} path={Paths.unit_orders} component={Screens.UnitOrders} />
    <Route exact={true} path={Paths.unit_order_details} component={Screens.UnitOrderDetails} />
    <Route exact={true} path={Paths.money_transitions} component={Screens.MoneyTransitions} />
    <Route
      exact={true}
      path={Paths.money_transition_details}
      component={Screens.MoneyTransitionDetails}
    />
    <Route exact={true} path={Paths.security_transitions} component={Screens.SecurityTransitions} />
    <Route
      exact={true}
      path={Paths.security_transition_details}
      component={Screens.SecurityTransitionDetails}
    />
    <Route exact={true} path={Paths.money_transfers} component={Screens.MoneyTransfers} />
    <Route
      exact={true}
      path={Paths.money_transfer_details}
      component={Screens.MoneyTransferDetails}
    />
    <Route exact={true} path={Paths.currency_conversions} component={Screens.CurrencyConversions} />
    <Route
      exact={true}
      path={Paths.currency_conversion_details}
      component={Screens.CurrencyConversionDetails}
    />
    <Route exact={true} path={Paths.security_transfers} component={Screens.SecurityTransfers} />
    <Route
      exact={true}
      path={Paths.security_transfer_details}
      component={Screens.SecurityTransferDetails}
    />

    <Route exact={false} path={Paths.dashboard} component={Screens.Dashboard} />
  </Switch>
);
